const clearCanvas = (store) => {
  store.deletePages(store.pages.map((page)=>page.id));
}

export {clearCanvas};